import { useQuery } from '@tanstack/react-query';
import { programDesignApi } from '../services/api';

export const useMasterActionCatalog = () => {
  return useQuery({
    queryKey: ['masterActionCatalog'],
    queryFn: async () => {
      const response = await programDesignApi.getCatalog();
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
